import GoogleStep1 from "./GoogleStep1.vue";
import GoogleButton from "@/components/auth/google_button.vue";
import { actionType } from "@/views/dashboard/workspace-integration/actionType";
import { CLASSROOM_SCOPE } from "@/constants";

export default function googleClassroomSteps(t) {
  return [
    {
      component: GoogleStep1,
      action: {
        component: GoogleButton,
        props: { scope: CLASSROOM_SCOPE, type: "permissions" },
        label: t("imports.connectGoogleClassroom"),
        actionType: actionType.submit,
        type: "primary",
      },
    },
  ];
}
